import { isInOutsideH5 } from '@fs/utils'
import CMHKLogoutInstance from '@/utils/CMHKLogout'
import { Toast } from 'vant'
import { i18n } from '@/i18n/login'
import pathnames from '@/config/EsopH5Pathname.js'
import { isComplianceAuditFlow } from '@/utils/complianceSession'
import goto, { getUrlParams } from '@/utils/goto'
const { VUE_MEMBER_H5 } = pathnames

export default response => {
    if (isInOutsideH5()) {
        if (location.href.includes('tradeRecom')) return response
        switch (response.data?.error?.code) {
            case 100034:
                // 互踢弹窗
                CMHKLogoutInstance.open()
                return Promise.reject(response)
            case 100008:
            case 100031:
            case 100033: {
                const isEsopApi = response?.config?.url?.indexOf('/esop/') !== -1
                console.log('outsideH5LogoutInterceptor isEsopApi = ', isEsopApi)

                // 检查是否为合规出入金场景，如果是则不显示错误提示
                const isCompliance = isComplianceAuditFlow()
                const isUserDetailApi = response?.config?.url?.includes('/uc/v1/UserDetail')

                // 只有在非合规场景或非UserDetail接口时才显示Toast
                if (!(isCompliance && isUserDetailApi)) {
                    const message = i18n.t('requestCode.dlsxqcxdl')
                    Toast({
                        forbidClick: true,
                        message: message,
                    })
                } else {
                    console.log('合规出入金场景下的 UserDetail 接口登录失效，跳过Toast提示')
                }
                localStorage.clear()

                // 合规出入金场景下不执行定时器跳转
                const query = getUrlParams()
                if (!(isCompliance && isUserDetailApi)) {
                    setTimeout(() => {
                        if (isEsopApi) {
                            goto(VUE_MEMBER_H5)
                        } else {
                            goto('login', {
                                query: {
                                    path: decodeURIComponent(location.href),
                                    ...query,
                                },
                            })
                        }
                    }, 2000)
                } else {
                    if (isEsopApi) {
                        goto(VUE_MEMBER_H5)
                    } else {
                        goto('login', {
                            query: {
                                path: decodeURIComponent(location.href),
                                ...query,
                            },
                        })
                    }
                }

                return Promise.reject(response)
            }
            default:
                break
        }
    }
    return response
}
